import React from "react";
import { Box, Typography } from "@mui/material";
import TextEditor from "../../../components/TextEditor";

function PrivacyPolicy({ edit, formData, onChangeTextEditor }) {
  return (
    <>
      <Typography sx={{ fontSize: "18px", marginBottom: "1rem" }}>
        Add Privacy Policy
      </Typography>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <TextEditor
          edit={edit}
          id="en"
          placeholder="Enter Privacy Policy in English"
          prefill={formData.privacyPolicy?.en || ""}
          onChangeTextEditor={onChangeTextEditor}
        />
        <TextEditor
          edit={edit}
          id="hi"
          placeholder="Enter Privacy Policy in Hindi"
          prefill={formData.privacyPolicy?.hi || ""}
          onChangeTextEditor={onChangeTextEditor}
        />
        <TextEditor
          edit={edit}
          id="fr"
          placeholder="Enter Privacy Policy in French"
          prefill={formData.privacyPolicy?.fr || ""}
          onChangeTextEditor={onChangeTextEditor}
        />
        <TextEditor
          edit={edit}
          id="es"
          placeholder="Enter Privacy Policy in Spanish"
          prefill={formData.privacyPolicy?.es || ""}
          onChangeTextEditor={onChangeTextEditor}
        />
      </Box>
    </>
  );
}

export default PrivacyPolicy;
